<template>
  <div>
    <loader :loading="loading"/>
    <div v-if="!loading">
      <page-title moduleIdentifier="shein" :title="$t('shein.account.label')">
        <div class="btnGroup" slot="header-right">
          <button @click="changeStatus(false)" v-bind:class="{ 'is-active': !sheinAccount.active }" class="btn btn--info btn--outline">
            Inativo
          </button>
          <button @click="changeStatus(true)" v-bind:class="{ 'is-active': sheinAccount.active }" class="btn btn--info btn--outline">
            Ativo
          </button>
        </div>
      </page-title>
      <div class="l-row vertical-flex">
        <div class="l-col-3@md img-account">
          <img v-if="sheinAccount.logo" :src="sheinAccount.logo"/>
          <i v-if="!sheinAccount.logo" class="icon-image2 no-photo"/>
        </div>
        <div class="l-col-9@md">
          <panel title="Dados da conta">
            <span class="ds-block"><strong>Nome:</strong> {{ sheinAccount.nickname }}</span>
          </panel>
        </div>
      </div>
      <div class="l-row">
        <div class="l-col-12@md">
          <panel title="Autenticação">
            <div slot="header-right">
              <button class="hint hint--left btn" @click="refreshToken" data-label="Renovar token"><i class="icon-sync icon-loop2"></i></button>
            </div>
            <span class="ds-block"><strong>Token de acesso:</strong> {{ sheinAccount.accessToken }}</span>
            <span class="ds-block"><strong>Token de renovação:</strong> {{ sheinAccount.refreshToken }}</span>
            <span class="ds-block"><strong>Data de expiração:</strong> {{ sheinAccount.expirationDate.replace('.000Z', '') | moment('DD/MM/YYYY HH:mm') }}</span>
          </panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Loader from '@/components/template/Loader'
  import PageTitle from '@/components/template/PageTitle'
  import ModuleLogo from '@/components/template/ModuleLogo'
  import notifier from '@/notifier'
  import api from '@/api'
  import Panel from '@/components/template/Panel'

  export default {
    props: {
      identifier: {
        type: String,
        required: false
      }
    },
    data: () => ({
      sheinAccount: {},
      loading: true
    }),
    async mounted () {
      if (!this.account) {
        await this.fetchAccounts({})
      }

      this.loading = false
    },
    methods: {
      ...mapActions('sheinAccounts', [
        'fetchAccounts',
        'setAccount'
      ]),
      isActive () {
        return {
          'success': this.sheinAccount.active,
          'error': !this.sheinAccount.active
        }
      },
      getStatusLabel (status) {
        if (status) {
          return 'shein.accounts.active.label'
        }
        return 'shein.accounts.inactive.label'
      },
      editAction () {
        return this.$router.push(`/` + this.sheinAccount.identifier)
      },
      async refreshToken () {
        this.loading = true

        try {
          const refreshedAccount = (await api.shein.refreshTokenManually(this.sheinAccount.identifier))

          this.sheinAccount = refreshedAccount

          this.setAccount(refreshedAccount)

          this.loading = false

          notifier.success(`Token da conta renovado com sucesso.`, 'Sucesso')
        } catch (error) {
          this.loading = false

          notifier.error('Erro na renovação do token da conta.', 'Erro')
        }
      },
      async changeStatus (status) {
        this.loading = true

        if (this.sheinAccount.active === status) {
          this.loading = false

          return false
        }

        try {
          await api.shein.updateAccountStatus(this.sheinAccount.identifier, status)

          this.sheinAccount.active = status

          this.loading = false

          notifier.success(`Status da conta alterado com sucesso.`, 'Sucesso')
        } catch (error) {
          this.loading = false

          notifier.error('Erro na alteração de status da conta.', 'Erro')
        }
      }
    },
    computed: {
      ...mapGetters('sheinAccounts', [
        'getAccount'
      ]),
      async account () {
        this.sheinAccount = await api.shein.getAccountByIdentifier(this.identifier)
        return this.sheinAccount
      }
    },
    components: {
      Loader,
      PageTitle,
      ModuleLogo,
      Panel
    }
  }
</script>

<style lang="sass" scoped>
  .img-account
    text-align: center
    padding: 30px 0

    img
      max-height: 100%
      margin: 5px 0 16px
      max-width: 150px

    .no-photo
      font-size: 150px
      color: darkgrey
</style>



// WEBPACK FOOTER //
// Edit.vue?40e6dbb6